import { takeEvery, put, call, select } from "redux-saga/effects"
// Constants
import {
  GET_ALL_CUSTOM_SKELETONS,
  GET_CUSTOM_SKELETON_BY_ID,
  POST_CUSTOM_SKELETON,
  GET_SKELETON_DEFAULT_FIELDS,
  PATCH_CUSTOM_SKELETON,
  DELETE_CUSTOM_SKELETON,
} from "./constants"
// Actions
import {
  getAllCustomSkeletonsAction,
  getAllCustomSkeletonsSuccessAction,
  getCustomSkeletonByIdSuccessAction,
  getSkeletonDefaultFieldsSuccessAction,
} from "./actions"
// Sagas
import {
  responseTypeIsError,
  responseTypeIsSuccess,
  manageErrorGenerator,
  manageSuccessGenerator,
} from "Containers/App/saga"

// selectors
import { selectCurrentToken, selectCurrentUser } from "Containers/Login/selectors"

// Utils
import { getCors, postCors, patchCors, deleteCors } from "Utils/rulesCors"
import { config } from "Utils/config"
import request from "Utils/request"

function* getAllCustomSkeletonsSaga() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/customSkeletons`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getAllCustomSkeletonsSuccessAction(response?.body))
      }
    }
  } catch (err) {
    console.error("[route] GET => /customSkeletons => ERROR => ", err)
  }
}

function* getCustomSkeletonById({ payload }) {
  const { customSkeletonId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/customSkeletons/${customSkeletonId}`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getCustomSkeletonByIdSuccessAction(response?.body))
      }
    }
  } catch (err) {
    console.error("[route] GET => /customSkeletons/:objectType/:customSkeletonId => ERROR => ", err)
  }
}

function* postSkeletonSaga({ payload }) {
  const { customSkeleton } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/customSkeletons`

  try {
    const response = yield call(request, requestURL, postCors({ customSkeleton }, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getAllCustomSkeletonsAction())
      }
    }
  } catch (err) {
    console.error("[route] POST => /customSkeletons => ERROR => ", err)
  }
}

function* patchSkeletonSaga({ payload }) {
  const { _etag, ...restPayload } = payload // Destructurer pour sortir _etag
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/customSkeletons/${restPayload?._id?.$oid}`

  try {
    const response = yield call(request, requestURL, patchCors(restPayload, specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getAllCustomSkeletonsAction())
      }
    }
  } catch (err) {
    console.error("[route] PATCH => /customSkeletons => ERROR => ", err)
  }
}

function* deleteSkeletonSaga({ payload }) {
  const { customSkeletonId } = payload
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/customSkeletons/${customSkeletonId}`

  try {
    const response = yield call(request, requestURL, deleteCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: true })
        yield put(getAllCustomSkeletonsAction())
      }
    }
  } catch (err) {
    console.error("[route] POST => /customSkeletons => ERROR => ", err)
  }
}

// DEFAULT FIELDS
function* getSkeletonDefaultFieldsSaga() {
  const token = yield select(selectCurrentToken)
  const specificHeaders = { token: token }
  const { FORM_BACK_URL } = config
  const requestURL = `${FORM_BACK_URL}/defaultFieldsSkeleton`

  try {
    const response = yield call(request, requestURL, getCors(specificHeaders))
    if (responseTypeIsError(response)) {
      yield call(manageErrorGenerator, { response, showMessageToUser: false })
    } else {
      if (responseTypeIsSuccess(response)) {
        yield call(manageSuccessGenerator, { response, showMessageToUser: false })
        yield put(getSkeletonDefaultFieldsSuccessAction(response?.body))
      }
    }
  } catch (err) {
    console.error("[route] GET => /customSkeletons => ERROR => ", err)
  }
}

function* customSkeletonsSaga() {
  yield takeEvery(GET_ALL_CUSTOM_SKELETONS, getAllCustomSkeletonsSaga)
  yield takeEvery(GET_CUSTOM_SKELETON_BY_ID, getCustomSkeletonById)
  yield takeEvery(PATCH_CUSTOM_SKELETON, patchSkeletonSaga)
  yield takeEvery(POST_CUSTOM_SKELETON, postSkeletonSaga)
  yield takeEvery(DELETE_CUSTOM_SKELETON, deleteSkeletonSaga)
  // DEFAULT FIELDS
  yield takeEvery(GET_SKELETON_DEFAULT_FIELDS, getSkeletonDefaultFieldsSaga)
}

export default customSkeletonsSaga
